import { ThemeEvents } from '@theme/events';

const PRICE_SELECTOR = '[data-add-to-cart-price]';

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function getQuantity(scope) {
  const input = scope.querySelector('quantity-selector-component input[ref="quantityInput"]');
  const value = input ? parseInt(input.value, 10) : 1;
  return Number.isFinite(value) && value > 0 ? value : 1;
}

function updatePriceLabels(scope) {
  if (!scope || !scope.querySelectorAll) return;
  const quantity = getQuantity(scope);
  scope.querySelectorAll(PRICE_SELECTOR).forEach((el) => {
    const unitPrice = parseInt(el.dataset.unitPrice, 10);
    if (!Number.isFinite(unitPrice)) return;
    el.textContent = ' — ' + formatMoney(unitPrice * quantity);
  });
}

function handleScopedEvent(event) {
  if (!(event.target instanceof Element)) return;
  const scope = event.target.closest('.shopify-section, dialog') || document;
  updatePriceLabels(scope);
}

document.addEventListener(ThemeEvents.quantitySelectorUpdate, handleScopedEvent);
document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  requestAnimationFrame(() => handleScopedEvent(event));
});

function init() {
  document.querySelectorAll('.shopify-section').forEach(updatePriceLabels);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
